import React from "react";
import { Box, Tooltip } from "@mui/material";
import SpeedIcon from "@mui/icons-material/Speed";
import { useTranslation } from "react-i18next";
import { WorkShiftTimeSlotItem, WorkTimeEventType } from "../../models/workShitTimeSlot/workShiftTimeSlotItem";
import { Base } from "../../framework/base";

interface WorkTimeautomationsIndicatorProps {
    slot: WorkShiftTimeSlotItem;
}

export const WorkTimeAutomationsIndicator = (props: WorkTimeautomationsIndicatorProps) => {
    const { t } = useTranslation();

    if (props.slot.workTimeEvents.length === 0) {
        return null;
    }

    const automationsDescription = (
        <div>
            {props.slot.workTimeEvents.map((event, i) => (
                <div key={i}>
                    {event.type === WorkTimeEventType.WorkTimeStarted && `${Base.dateStrToOriginalTimezoneTimeStr(props.slot.orgStartDate)}: `}
                    {event.type === WorkTimeEventType.WorkTimeEnded && `${Base.dateStrToOriginalTimezoneTimeStr(props.slot.orgEndDate)}: `}

                    {event.source === "VehicleDriverUpdated" && (
                        event.type === WorkTimeEventType.WorkTimeStarted
                            ? t("workTime.digiCardInserted")
                            : t("workTime.digiCardRemoved")
                    )}
                    {event.source === "VehicleDriving" && t("workTime.vehicleDriving")}
                    {event.source === "VehicleInactive" && t("workTime.vehicleInactive")}
                </div>
            ))}
        </div>
    );

    return (
        <Box
            sx={{
                m: 1,
                position: "relative",
            }}
        >
            <Tooltip title={automationsDescription}>
                <SpeedIcon color="primary" />
            </Tooltip>
        </Box>
    );
};
